export default (function () {
  var copyrightEles = document.querySelectorAll('.copyright-year');
  var year = new Date().getFullYear();
  if (!copyrightEles.length) return;
  copyrightEles.forEach(function (ele) {
    ele.innerText = year;
  });
});